import { useSettingsStore } from '@/stores/settings';

export const SPLIT_MAIN_LAYOUT_SELECTOR = '.ar-sidebar-layout__main';
export const SPLIT_MAIN_BREAKPOINT = 960;

interface SplitRouteAvailabilityOptions {
	breakpoint?: number;
	requireSplitEnabled?: boolean;
}

interface ResolveSplitRouteNameOptions extends SplitRouteAvailabilityOptions {
	splitRouteName: string;
	fallbackRouteName: string;
}

export const getMainLayoutWidth = (): number => {
	const mainLayout =
		typeof document !== 'undefined'
			? document.querySelector(SPLIT_MAIN_LAYOUT_SELECTOR)
			: null;
	if (
		mainLayout &&
		typeof (mainLayout as HTMLElement).getBoundingClientRect === 'function'
	) {
		return (mainLayout as HTMLElement).getBoundingClientRect().width;
	}

	if (typeof window !== 'undefined') {
		return window.innerWidth;
	}

	return 0;
};

export const isSplitRouteAvailable = ({
	breakpoint = SPLIT_MAIN_BREAKPOINT,
	requireSplitEnabled = true,
}: SplitRouteAvailabilityOptions = {}): boolean => {
	const isWideEnough = getMainLayoutWidth() >= breakpoint;
	if (!isWideEnough) {
		return false;
	}

	if (!requireSplitEnabled) {
		return true;
	}

	return useSettingsStore().splitViewEnabled;
};

export const resolveSplitRouteName = ({
	splitRouteName,
	fallbackRouteName,
	breakpoint = SPLIT_MAIN_BREAKPOINT,
	requireSplitEnabled = true,
}: ResolveSplitRouteNameOptions): string => {
	return isSplitRouteAvailable({ breakpoint, requireSplitEnabled })
		? splitRouteName
		: fallbackRouteName;
};
